module.exports = __webpack_public_path__ + "img/Service-ability-03.907600f4.png";